import { Component } from '@angular/core';

@Component({
  selector: 'bm-ext-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {}
